<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
    </div>
    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="handleAdd" >新建</a-button>
    </div>
    <template>
      <a-table ref="table"
               :columns="columns"
               rowKey="id"
               :dataSource="treeList"
      >
        <span slot="action" slot-scope="text, record">
        <template >
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" v-if="record.is_default!=1" />
            <a-popconfirm title="确定删除分类吗"  v-if="record.is_default!=1"  @confirm="deleteCate(record)"  okText="确定" cancelText="取消">
            <a href="javascript:;">删除</a>
            </a-popconfirm>
        </template>
      </span>
      <span slot="name" slot-scope="name,record">
          <span v-if="record.status==1">{{record.name}}</span>
          <span v-else style="color: #999">{{record.name}}</span>
      </span>
      <span slot="status" slot-scope="status">
        <a-badge status="success" v-if="status==1" text="显示" />
        <a-badge status="default" v-else text="隐藏" />
      </span>

        <span slot="rank" slot-scope="text,record">
        <template >
        <editable-cell :text="text" @change="onRankChange(record.id, 'rank', $event)"/>
        </template>
      </span>


      </a-table>
    </template>
    <a-modal
      title="操作"
      :width="800"
      v-model="visible"
      @ok="handleOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="名称"
          hasFeedback
        >
          <a-input v-model="formData.name"
         placeholder="请输入分类名称"/>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="图标"
          hasFeedback
        >
          <pic-uploader
                :file-list="formData.pic"
          />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="状态"
          hasFeedback
        >
          <a-switch checkedChildren="显示" unCheckedChildren="隐藏"  v-model="formData.status" />
        </a-form-item>
        </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleOk">保存</a-button>
      </template>
    </a-modal>

  </a-card>
</template>

<script>
  import moment from 'moment'
  import EditableCell from '@/components/EditableCell/'
  import { getCateTreeList,editCate,addCate,deleteCate,getCateDetail,getCateList,setCateRank  } from '@/api/goods'
  import PicUploader from '@/components/PicUploader/'

  export default {
    name: 'GoodsCateList',
    components: {
      PicUploader,EditableCell
    },
    data () {
      return {
        saveLoading:false,
        visible: false,
//        description: '全校班级管理。',
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12 },
        },
        form: this.$form.createForm(this),
        mdl: {},

        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {
        },
        // 表头
        columns: [
          {
            title: '名称',
            dataIndex: 'name',
            scopedSlots: { customRender: 'name' },
          },
          {
            title: '状态',
            dataIndex: 'status',
            scopedSlots: { customRender: 'status' },
          },
          {
            title: '排序',
            dataIndex: 'rank',
            scopedSlots: { customRender: 'rank' },
          },
          {
            table: '操作',
            dataIndex: 'action',
            width: '250px',
            scopedSlots: { customRender: 'action' },
          }
        ],
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          console.log('loadData');
        },
        treeList:[

        ],
        cateList:[

        ],
        formData:{
          name:'',
          id:0,
          pic:[],
          status:true,
        },
        selectedRowKeys: [],
        selectedRows: [],
      }
    },
    created () {
//      getRoleList({ t: new Date()})
    },
    computed:{
      options (){
        return  this.treeList;
      }
    },
    mounted(){
    let that = this;
      that.fetch();
    },
    methods: {
      fetch(){
        let that = this;

        getCateList()
            .then(res => {
              that.cateList =  res.data
              that.treeList =  res.data
            })
      },
      handleCancel(){
        this.visible = false
      },
     // 增
    handleAdd(record) {
      let that = this;
      that.visible = true;
      that.form.resetFields();
      that.formData = {
        name:'',
        id:0,
        pic:[],
        status:true,
      }
      setTimeout( () =>{
        that.form.setFieldsValue({ ...that.formData });
      });
    },
    // 改
    handleEdit(record) {
      let self = this
      this.visible = true
//      this.form.resetFields();
      self.form.setFieldsValue({
        name:'',
        rank:0,
      });
      this.formData.id = record.id;
      getCateDetail({ id: record.id }).then(res => {
        setTimeout(()=>{
          self.form.setFieldsValue({...res.data});
        },1)
        self.formData.name = res.data.name;
        self.formData.pic = res.data.pic;
        self.formData.parents_ids = self.cateParentsIds(record.id);
        self.formData.status = res.data.status==1 ? true : false;
      })
      // console.log(this.mdl)
    },
    // 增改 处理
    handleOk(e) {
      let self = this
      if(!self.formData.name){
        self.$message.error('请输入分类名称');
        return ;
      }
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values)
          console.log('Received valuess of formData: ', self.formData)
          self.saveLoading = true;
          if(self.formData.id) {
            editCate(Object.assign(self.formData,values)).then(res => {
              self.$message.success('修改成功')
              self.fetch();
              self.visible = false;
              self.saveLoading = false;
            }).catch(err =>{
              self.$message.error(err.data.msg);
              self.saveLoading = false;
            })
          }else{
            console.log(Object.assign(self.formData,values))
            addCate(Object.assign(self.formData,values)).then(res => {
              self.$message.success('新增成功')
              self.fetch();
              self.visible = false
              self.saveLoading = false;
            }).catch(err =>{
              self.$message.error(err.data);
              self.saveLoading = false;
            })
          }
        }
      })
    },
     // 删
      deleteCate(record) {
        let self = this
        deleteCate({ id: record.id  }).then(res => {
          self.$message.success('删除成功')
          self.fetch();
      }).catch(err =>{
          self.$message.error(err.data.msg)
        })
    },
      cateParentsIds(cate_id){
        let self = this;
        let parent_id = cate_id;
        let parents_ids = [];
        while(parent_id != 0){
          cate_id = parent_id;
          parent_id = self.getListParentId(cate_id);
          if(parent_id >0){
            parents_ids.push(parent_id+'');
            continue;
          }
          break;
        }
        return parents_ids.reverse(parents_ids);
      },
      getListParentId(cate_id){
        let self = this;
        let parent_id = 0;
        self.cateList.map(function (item) {
          if(item.id == cate_id){
            parent_id = item.parent_id
            return ;
          }
        })
        return parent_id;
      },

      onRankChange(key, dataIndex, value) {
        let self = this;
        setCateRank({
          id: key,
          rank:value
        }).then(res => {
          self.fetch();
        }).catch(err =>{
          self.$message.error(err.data.msg)
        })
      },
    },
    watch: {
      /*
      'selectedRows': function (selectedRows) {
        this.needTotalList = this.needTotalList.map(item => {
          return {
            ...item,
            total: selectedRows.reduce( (sum, val) => {
              return sum + val[item.dataIndex]
            }, 0)
          }
        })
      }
      */
    }
  }
</script>
